import request from '@/utils/request'

// 平台账户查询
export function getAccountQuery(data) {
  return request({
    url: '/settlement/account',
    method: 'post',
    data: data
  })
}
// 已绑定银行卡信息
export function getBindingCard(data) {
  return request({
    url: '/settlement/bank_card',
    method: 'post',
    data: data
  })
}
// 资金总收付统计tab
export function getMoneyStatisticsTab(data) {
  return request({
    url: '/settlement/money_stat_tab',
    method: 'post',
    data: data
  })
}
// 资金总收付统计
export function getMoneyStatistics(data) {
  return request({
    url: '/settlement/money_stat_list',
    method: 'post',
    data: data
  })
}
// 资金总收付导出
export function exportMoneyStatistics(data) {
  return request({
    url: '/settlement/export_excel',
    method: 'post',
    data: data
  })
}
